import React, { useState } from 'react';
import { InputGroup, Button, InputBase } from '../../../../../../../common/@roma/src';
import { useTranslator } from '../../../../../../components/i18n/useTranslator';
import { LabelEditContentProps } from '../labelComponentPropTypes';
import { updateLabel } from '../../../../../../../common/labels/labelActions';
import { useDispatch } from 'react-redux';
import { LABEL_NAME_MAX_LENGTH } from '../../../../../../../common/labels/labelConstants';

const LabelRenameField: React.FC<LabelEditContentProps> = ({ label }) => {
    const translate = useTranslator('popup', 'labels.edit');
    const dispatch = useDispatch();

    const [name, setName] = useState<string>(label.name);

    const handleNameChange = () => {
        dispatch(updateLabel(label.id, { name }));
    };

    return (
        <InputGroup
            size="sm"
            aria-label="Edit label name"
            onChange={setName}
            trailingAddon={
                <Button color="primary" size="sm" onClick={handleNameChange} isDisabled={!name}>
                    {translate('rename')}
                </Button>
            }
        >
            <InputBase type="text" placeholder="Edit name" value={name} maxLength={LABEL_NAME_MAX_LENGTH} />
        </InputGroup>
    );
};

export default LabelRenameField;
